import { createSlice } from '@reduxjs/toolkit';

// Page state slice - minimal state management
// All async operations handled by RTKQ

const initialState = {
  data: {},
  activeSection: null,
  status: 'idle'
};

const coursePageSlice = createSlice({
  name: 'coursePage',
  initialState,
  reducers: {
    updateTaskResult: (state, action) => {
      const { moduleId } = action.payload;
      const targetModule = state.data.pageRows
        ?.flatMap(row => row.pageModules)
        ?.find(module => module.id === moduleId);

      if (targetModule) {
        if (!targetModule.data.params.taskResults) {
          targetModule.data.params.taskResults = [];
        }
        targetModule.data.params.taskResults.push(action.payload);
      } else {
        console.warn('Page: Target module not found for task result update', { moduleId });
      }
    },
    clearPage: () => {
      return initialState;
    },
    setPageData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
      state.status = 'succeeded';
    },
  }
});

export const { updateTaskResult, clearPage, setPageData } = coursePageSlice.actions;

export default coursePageSlice.reducer;
